<template>
    <div class="all-area">
        <div class="page">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-cell v-for="item in noticeList" :key="item" class="notice-item" >
                    <van-row >
                        <van-row type="flex" justify="space-between">
                            <van-col class="notice-title">
                                {{item.title}}
                            </van-col>
                            <van-col class="notice-time">
                                {{item.createdate}}
                            </van-col>
                        </van-row>
                        <van-row class="notice-content" >
                            <div v-html="item.content" class="foo"></div>
                        </van-row>
                    </van-row>

                </van-cell>
            </van-list>
        </div>
    </div>

</template>

<script>
    import {noticeList} from '@/api/api'
    import { Toast } from 'vant';
    export default {
        name: "notice-center",
        data(){
            return {
                noticeList: [
                    {
                        title:'篮球知识',
                        time:'2020-5-6',
                        content:'篮球运动租金新陈代谢，身体更健康'
                    },
                    {

                        title:'羽毛球馆开业',
                        time:'2020-5-6',
                        content:'新的羽毛球馆开业啦，新增设8个羽毛球场地'
                    },
                    {
                        title:'乒乓球赛',
                        time:'2020-5-6',
                        content:'某体育馆举办乒乓球赛事，奖金高达1w'
                    }
                ],
                loading: false,
                finished: true,

            }
        },
        created(){
            this.getNoticeList()
        },
        methods:{
            getNoticeList(){
                noticeList().then(res=>{
                    if (res.code==0){
                        this.noticeList = res.data.list

                    }
                })
            },
            onLoad(){

            }
        }
    }
</script>

<style scoped>
    .all-area{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background:rgba(245,245,245,1);
    }
    .page{
        margin-top: 26px;
        margin-right: 16px;
        margin-left: 16px;
    }
    .notice-item{
        width: 100%;
        height: auto;
        background:rgba(255,255,255,1);
        border-radius:12px;
        margin-bottom: 16px;
    }
    .notice-title{
        font-size:17px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:24px;
    }
    .notice-time{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(153,158,168,1);
        line-height:17px;
    }
    .notice-time{
        font-size:15px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:21px;
        margin-top: 9px;
    }
</style>